// Auto generated file, do not manually modify!
// com.hotpads.yourrentalapi.enums.CtaAction

export enum CtaAction {
  CREDIT_CLIMB = 'CREDIT_CLIMB',
  PAYMENTS_DASHBOARD = 'PAYMENTS_DASHBOARD',
  PCR_DASHBOARD_ACTION = 'PCR_DASHBOARD_ACTION',
  RENTER_INSURANCE = 'RENTER_INSURANCE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  VIEW_LEASE = 'VIEW_LEASE',
  VIEW_LEASE_RENEWAL = 'VIEW_LEASE_RENEWAL',
}

export const CtaAction_values = [
  CtaAction.CREDIT_CLIMB,
  CtaAction.PAYMENTS_DASHBOARD,
  CtaAction.PCR_DASHBOARD_ACTION,
  CtaAction.RENTER_INSURANCE,
  CtaAction.SEND_MESSAGE,
  CtaAction.VIEW_LEASE,
  CtaAction.VIEW_LEASE_RENEWAL,
] as const;
